/**
 * @generated SignedSource<<d92af2082f790a3e988e31b37ac9f134>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileQuery$variables = {
  uuid: string;
};
export type ProfileQuery$data = {
  readonly profile: {
    readonly name: string;
    readonly insertedAt: string;
    readonly hasProfileImage: boolean;
    readonly votes: number;
    readonly eliteSeatProgress: {
      readonly currentLevelName: string | null;
      readonly currentTier: number;
      readonly wagerAmountUsd: number;
    };
  };
};
export type ProfileQuery = {
  variables: ProfileQuery$variables;
  response: ProfileQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uuid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "UserProfile",
    "kind": "LinkedField",
    "name": "profile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "insertedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasProfileImage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "votes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PublicEliteSeatProgress",
        "kind": "LinkedField",
        "name": "eliteSeatProgress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentLevelName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentTier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wagerAmountUsd",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a933011af7da9ad49f717b1aa43bbe33",
    "id": null,
    "metadata": {},
    "name": "ProfileQuery",
    "operationKind": "query",
    "text": "query ProfileQuery(\n  $uuid: String!\n) {\n  profile(uuid: $uuid) {\n    name\n    insertedAt\n    hasProfileImage\n    votes\n    eliteSeatProgress {\n      currentLevelName\n      currentTier\n      wagerAmountUsd\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1d34f79429ce46ea4b4ca4cf1336bbd";

export default node;
